import CloseIcon from "@mui/icons-material/Close"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Grid from "@mui/material/Unstable_Grid2"
import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { Box, DialogTitle, IconButton, List, ListItem, Tab, Typography } from "@mui/material"
import ListItemText from "@mui/material/ListItemText"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useContext, useEffect } from "react"
import { useDispatch } from "react-redux"
import TokenContext from "../../context/TokenContext"
import CustomSearchSelect from "../CustomSearchSelect"
import { TabContext, TabList, TabPanel } from "@mui/lab"


const ModalDescripción = ({ open, handleClose, modalTitle, modalDescription, item }) => {
  const token = useContext(TokenContext)
  const dispatch = useDispatch()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  const [valuePrimerTab, setValuePrimerTab] = useState('1'); //value del tablist

  const defaultValues = {
    valoracionModal: null,
    valoracionLiderModal: null,
  }
  
  const { handleSubmit, setValue, reset, ...methods } = useForm({
    shouldUnregister: false,
    defaultValues,
    mode: "onChange",
    shouldFocusError: true,
  })
    
  const submitDatos = () => {
    handleClose()
    reset()
    setValuePrimerTab("1")
  }

  const handleChangePrimerTAB = (event, newValue) => {
    setValuePrimerTab(newValue);
  };

  return (
    <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      <TabContext value={valuePrimerTab}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <TabList
              aria-label="scrollable force tabs example"
              onChange={handleChangePrimerTAB} variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              textColor="secondary"
              indicatorColor="secondary"
            >
              <Tab label={modalTitle} value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
            </TabList>
          </Box>
          <TabPanel value="1">



        <List sx={{ width: "100%" }}>
            


        <ListItem>
            <ListItemText>
              <strong>Descripción: </strong>
              {modalDescription}
            </ListItemText>
          </ListItem>

          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <TabList
              aria-label="scrollable force tabs example"
              onChange={handleChangePrimerTAB} variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              textColor="secondary"
              indicatorColor="inherit"
            >
              <Tab label="Valoración" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
            </TabList>
          </Box>  

          {item && item.definicionderangos && item.definicionderangos.split('\n').map((item, index) => {
            if (item.includes(":")) {
              const [firstPart, secondPart] = item.split(":");
              return (
                <ListItem key={index}>
                  <ListItemText>
                    <strong style={{ fontSize: '0.8rem' }}>{firstPart.trim()}:</strong> <span style={{ fontSize: '0.8rem' }}>{secondPart.trim()}</span>
                  </ListItemText>
                </ListItem>
              );
            } else {
              return (
                <ListItem key={index}>
                  <ListItemText>{item}</ListItemText>
                </ListItem>
              );
            }
          })}
          
        </List>
        <Grid container spacing={2} sx={{ mt: 2,justifyContent:"center" }}>
            <Button
                type="submit"
                variant="contained"
                onClick={handleSubmit(submitDatos)}
              >
                Cerrar
              </Button>
        </Grid>
        </TabPanel>
        </TabContext>
      </DialogContent>
    </Dialog>
  )
}
export default ModalDescripción
